module.exports = __webpack_public_path__ + "img/startups.05938756.png";